import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import createPersistedState from "vuex-persistedstate";

const PERSIST_PATHS = [
  "classReminder.lessonId",
  "classReminder.lessonList",
  "searchHistory.keywords",
  "saveAsFileMap.saveAsFileMap",
  "learningRecord.lastLesson",
  "live.isMirror",
  "live.openBeauty",
  "live.beautyOptions",
  "live.showRaiseHand",
  "live.toolbarPosition",
  // "live.cameraList",
  // "live.currentCameraDevice",
  // "live.microphoneList",
  // "live.currentMicDevice",
  // "live.speakerList",
  // "live.currentSpeakerDevice",
];

Vue.use(Vuex);
// https://webpack.js.org/guides/dependency-management/#requirecontext
const modulesFiles = require.context("./modules", true, /\.js$/);

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, "$1");
  const value = modulesFiles(modulePath);
  modules[moduleName] = value.default;
  return modules;
}, {});
const store = new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: modules,
  getters,
  plugins: [
    createPersistedState({
      paths: PERSIST_PATHS,
    }),
  ],
});

export default store;
